export default function () {
	/**
	 * must be same as PHP functions
	 */
	Nette.validators.JenPraceUsersSecurityPasswordValidatorPasswordValidatorRule_baseTest = (elem, args, val) => {
		if (val.length < args[0]) {
			return false;
		}

		let regTest = true;
		Object.keys(args[1]).forEach((key) => {
			let r = new RegExp(key);
			if (r.test(val) === false) {
				regTest = false;
			}
		});
		if (!regTest) {
			return false;
		}

		return true;
	};

	/**
	 * must be same as PHP functions
	 */
	Nette.validators.JenPraceUsersSecurityPasswordValidatorPasswordValidatorRule_jpBlacklistTest = (
		elem,
		args,
		val
	) => {
		const includesValue = args[0].some((element) => {
			return element.toLowerCase() === val.toLowerCase();
		});
		//console.log(includesValue);
		return !includesValue;
	};
}
